import { TablePage } from 'web-mojo';
import { DeviceHistoryList } from '@portal/models/DeviceHistory.js';

export default class DeviceHistoryPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Activity Report',
            icon: "bi-clock-fill",
            pageName: 'history_report',
            Collection: DeviceHistoryList,

            viewDialogOptions: { header: false },
            requiresGroup: true,
            defaultQuery: {
                sort: '-id',
            },

            columns: [
                { label: "When", key: "created|datetime" },
                { label: "User", key: "user|default('device')" },
                { label: "Action", key: "action" },
                { label: "Source", key: "source" },
                {
                    label: "Lock",
                    key: "lock_engaged",
                    formatter: "yesnoicon('bi bi-lock-fill text-danger', 'bi bi-unlock-fill text-success')",
                },
                {
                    label: "Latch",
                    key: "latch_opened",
                    formatter: "yesnoicon('bi bi-door-open text-warning', 'bi bi-door-closed text-success')",
                },
                { label: "Device", key: "device.name|default(model.device.uuid)" },
            ],

            emptyMessage: 'No activity found.',

            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: false
            },

            showRefresh: true,
            showAdd: false,
            showExport: true,

            tableViewOptions: {
                clickAction: "none",
                hideActivePillNames: ["device__group"]
            },

            ...options,
        });
    }
}
